import LayoutPage from "@/views/shared/LayoutPage";

export default [
  {
    path: "/purchase-request",
    component: LayoutPage,
    children: [
      {
        path: "/purchase-request",
        name: "purchase-request-list",
        component: () =>
          import("@/views/PurchaseRequest/PurchaseRequestListPage.vue"),
        meta: {
          title: "Purchase Request List",
          titleLocalizationCode: "Purchase_Request_List",
          desc: "Purchase request list page",
          descLocalizationCode: "Purchase_Request_List_Page",
          sidebarElement: false,
          permissionCode: "PurchaseRequest.Read",
        },
      },
      {
        path: "/purchase-request/add",
        name: "purchase-request-add",
        component: () =>
          import("@/views/PurchaseRequest/PurchaseRequestAddPage.vue"),
        meta: {
          title: "Purchase Request Add",
          titleLocalizationCode: "Purchase_Request_Add",
          desc: "Purchase request add page",
          descLocalizationCode: "Purchase_Request_Add_Page",
          sidebarElement: false,
          permissionCode: "PurchaseRequest.Add",
        },
      },
      // {
      //     path: "/purchase-request/item",
      //     name: "purchase-item",
      //     component: () => import("@/views/PurchaseRequest/PurchaseRequestItemPage.vue"),
      //     meta: { title: "Purchase Request Item", desc:"Purchase request item page", sidebarElement: false}
      // },
    ],
  },
];
